import { defineDefaultEnumValue, defineEnumClampFunction } from 'src/lib/enum';

export const APPLICATION_BAR_HEIGHT = 66;

export const DOCUMENT_SCORE_PANEL_WIDTH = 54;
export const DOCUMENT_SCORE_PANEL_HEIGHT = 57;
export const DOCUMENT_LOCKED_SCORE_PANEL_HEIGHT = 30;
export const DOCUMENT_SCORE_SIZE = 35;
export const DOCUMENT_GENERATION_FORM_WIDTH = 429;
export const DOCUMENT_LEFT_PANEL_WIDTH_EXPANDED = 510;
export const DOCUMENT_LEFT_PANEL_WIDTH_COLLAPSED = 80;

export const BLOG_ACTIONS_BAR_HEIGHT = 54;
export const TEXT_DETAILS_PANEL_WIDTH = 580;

export const BANNER_PERFORMANCE_PREDICTIONS_HEIGHT = 48;
export const BANNER_WEBINAR_HEIGHT = 56;

/**
 * "Insights" panel tab
 * @enum {string}
 * @property {TEXT_DETAILS_PANEL_TAB} DEFAULT - default generation tool
 * @property {EnumClampFunction<TEXT_DETAILS_PANEL_TAB>} clamp - function that clamps the value to the enum
 */
export const TEXT_DETAILS_PANEL_TAB = {
  performance: 'performance',
  brandPolicy: 'brandPolicy',
} as const;
export type TextDetailsPanelTab =
  (typeof TEXT_DETAILS_PANEL_TAB)[keyof typeof TEXT_DETAILS_PANEL_TAB];
defineDefaultEnumValue(TEXT_DETAILS_PANEL_TAB, TEXT_DETAILS_PANEL_TAB.brandPolicy);
defineEnumClampFunction(TEXT_DETAILS_PANEL_TAB, TEXT_DETAILS_PANEL_TAB.brandPolicy);

const TEXT_DETAILS_PANEL_TAB_LABELS = {
  [TEXT_DETAILS_PANEL_TAB.performance]: 'Performance',
  [TEXT_DETAILS_PANEL_TAB.brandPolicy]: 'Brand voice',
};
export const getTextDetailsPanelTabLabel = (tab: TextDetailsPanelTab) =>
  TEXT_DETAILS_PANEL_TAB_LABELS[tab] || '';
